<template>
    <div id="main" class="app-main">
        <router-view ></router-view>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                theme: this.$store.state.app.themeColor
            };
        },
        created () {
            this.$store.commit('clearAuth');
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            document.getElementsByTagName('body')[0].className = 'theme-default';
        },
        mounted () {
            // let token = localStorage.getItem("token");
            // console.log(this.$router );
            // console.log(document.URL);
            //挂载完成后，判断浏览器是否支持popstate
            // if (window.history && window.history.pushState) {
            //     history.pushState(null, null, document.URL);
            //     // window.addEventListener('popstate', this.goBack, false);
            // }
        },
        // destroyed(){
        //     window.removeEventListener('popstate', this.goBack, false);
        // },
        beforeDestroy () {

        },
        methods: {
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                this.$store.commit("setMobile",!!flag);
                return flag;
            },
            goBack(){
              console.log("goback")
              // this.$router.push({name:'m_home'})
              this.$router.go(-1)
                // this.$router.replace({path: '/'});
                //replace替换原路由，作用是避免回退死循环
            }
        }
    };
</script>

<style lang="less">
html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    overflow: hidden;
    /*min-width: 1000px;*/
}
.app-main{
    width: 100%;
    height: 100%;
}
    .tool-row,.pager-row{
        height: 30px;
    }
    .ivu-page{
        margin: 10px auto;
    }
    .float-clear-wall{
        width: 100%;
        clear: both;
    }
    .ivu-modal-wrap.large-modal .ivu-modal{
        top: 40px;
    }
</style>
